import { createAsyncThunk } from "@reduxjs/toolkit";


import * as URL from "helpers/url_helper";
import { get, post, del, put } from "helpers/api_helper";

export const getContactList = createAsyncThunk(
  "getContactList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(`${URL.GET_CONTACT_US}`, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  }
);